import { axios } from "utils";

import { ADMIN_IMPERSONATIONS_URL as endpoint } from "consts";

type StartImpersonationResponseBody = {
  sessionId: string;
  redirectUrl: string;
  expiresAt: string;
};

export const startImpersonation = async (data: { userId: string; farmId: string }): Promise<StartImpersonationResponseBody> =>
  axios.post(`${endpoint}`, { data });
